(function(){
    'use strict'

    angular
    .module('app.tiposPlanilla')
    .controller('TiposPlanilla', TiposPlanilla);

    TiposPlanilla.$inject = ['$animationsSrv', 'TiposPlanillaService', 'logger', '$location', 'UserInfoService'];

    function TiposPlanilla($animationsSrv, TiposPlanillaService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.tiposPlanilla = [];
        vm.title = 'Tipos Planilla';

        vm.goToEdit = function(tipoPlanilla){
            
            var path = '/editar-tipo-planilla/';

            if(tipoPlanilla){
                $location.path(path + tipoPlanilla.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = TiposPlanillaService.getAll(UserInfoService.getCompaniaId());

            promise
            .then(function(tiposPlanilla){
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los tipos de planilla.');
                        break;
                }
                
            });
        };

        vm.delete = function(tipoPlanilla){
            var promise = TiposPlanillaService.remove(tipoPlanilla);
            
            promise
            .then(function(response){
                vm.tiposPlanilla = vm.tiposPlanilla.filter(function(u) {
                    return u.id !== tipoPlanilla.id;
                });
                logger.success('Tipo de Planilla eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el tipo de planilla');
                        break;
                }
                
            });   
        };

    }
})();